export const formatNumber = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const n = Number(value);
  if (Number.isNaN(n)) return "-";
  return new Intl.NumberFormat("id-ID").format(n);
};

export const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const n = Number(value);
  if (Number.isNaN(n)) return "-";
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(n);
};

export const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("id-ID", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
};

export const sanitizePhone = (phone) => String(phone || "").replace(/\D/g, "");

export const getInitial = (name) =>
  String(name || "U").trim().charAt(0).toUpperCase();

export const getFurnishingLabel = (value) => {
  const map = {
    unfurnished: "Unfurnished",
    semi_furnished: "Semi Furnished",
    fully_furnished: "Fully Furnished",
  };
  return map[value] || value || "-";
};

export const getOrientationLabel = (value) => {
  const map = {
    utara: "Utara",
    selatan: "Selatan",
    timur: "Timur",
    barat: "Barat",
    timur_laut: "Timur Laut",
    tenggara: "Tenggara",
    barat_laut: "Barat Laut",
    barat_daya: "Barat Daya",
    hook: "Hook",
  };
  return map[value] || value || "-";
};

export const getConditionLabel = (value) => {
  const map = {
    baru: "Baru",
    sangat_bagus: "Sangat Bagus",
    bagus: "Bagus",
    cukup: "Cukup",
    perlu_renovasi_ringan: "Perlu Renovasi Ringan",
    perlu_renovasi_berat: "Perlu Renovasi Berat",
  };
  return map[value] || value || "-";
};

export const getListingSourceLabel = (value) => {
  const map = {
    user: "User",
    marketing: "Marketing",
    admin: "Admin",
  };
  return map[value] || value || "-";
};

export const getStatusLabel = (value) => {
  const map = {
    for_sale: "Dijual",
    for_rent: "Disewakan",
    draft: "Draft",
    published: "Published",
  };
  return map[value] || value || "-";
};

export const getApprovalLabel = (value) => {
  const map = {
    approved: "Approved",
    pending: "Pending Review",
    rejected: "Rejected",
  };
  return map[value] || "Draft";
};

export const buildLocationText = (property) => {
  if (property?.location) return property.location;
  return [property?.village, property?.district, property?.city, property?.province]
    .filter(Boolean)
    .join(", ");
};

export const groupFeatures = (features = []) => {
  const groups = new Map();

  features.forEach((item) => {
    const groupName = item?.group?.name || "Fitur Properti";
    if (!groups.has(groupName)) groups.set(groupName, []);
    groups.get(groupName).push(item);
  });

  return Array.from(groups.entries()).map(([name, items]) => ({
    name,
    items,
  }));
};

export const safeHtml = (html) => html || "<p>Tidak ada deskripsi.</p>";
